module.exports = __webpack_public_path__ + "media/theme/icon__itunes-abd3c20e.svg";